module.exports = __webpack_public_path__ + "media/src/images/icons/facebook-55ad8285bf492f25c51d2801fa2e033e.svg";